import { PureComponent } from 'react';
import { connect } from 'react-redux';

import BuyTogether from './BuyTogether.component';

import BrowserDatabase from 'Util/BrowserDatabase';
import BuyTogetherQuery from 'Query/BuyTogether.query';
import CartQuery from 'Query/Cart.query';

import { fetchQuery, fetchMutation } from 'Util/Request';
import { showNotification } from 'Store/Notification/Notification.action';

const CartDispatcher = import(/* webpackMode: "lazy", webpackChunkName: "dispatchers" */'Store/Cart/Cart.dispatcher');

export const mapStateToProps = (state) => ({
    items: state.BuyTogetherReducer.items,
    default_display_currency_code: state.ConfigReducer.default_display_currency_code
});

export const mapDispatchToProps = (dispatch) => ({
    updateCartData: (cartData) => CartDispatcher.then(
        ({ default: dispatcher }) => dispatcher._updateCartData(cartData, dispatch)
    ),
    showNotification: (type, message) => dispatch(showNotification(type, message))
});

export class BuyTogetherContainer extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            isLoading: false
        }
    }

    containerFunctions = {
        onItemClick: this.onItemClick.bind(this),
        onButtonClick: this.onButtonClick.bind(this)
    };


    containerProps = () => {
        const { products, isLoading } = this.state;
        const { items, default_display_currency_code } = this.props;

        return {
            products,
            isLoading,
            items,
            default_display_currency_code
        }
    }

    onItemClick(sku) {
        const { products } = this.state;
        const { items } = this.props;

        let newProducts = [];

        if (products.find(item => item.sku === sku)) {
            newProducts = products.filter(item => item.sku !== sku);
        } else {
            const product = items.filter(item => item.sku === sku );

            newProducts = [...products, { sku, price: product[0].price_range.minimum_price.final_price.value }];
        }

        this.setState({
            products: newProducts
        })
    }

    onButtonClick() {
        const { products } = this.state;
        const { showNotification } = this.props;

        const quote_id = BrowserDatabase.getItem('guest_quote_id');

        if (products.length > 0) {
            const input = {
                sku: products.map(item => item.sku),
                quote_id
            }

            this.setState({ isLoading: true });

            return fetchMutation(BuyTogetherQuery.addProducts(input)).then(
                ({ saveGroupProducts: { status } }) => {
                    if (status === 'success') {
                        this.handleSuccess();
                    } else {
                        this.handleError();
                    }
                 },
                this.handleError
            );

        } else {
            showNotification('error', __('Please select at least one product'))
        }
    }

    handleSuccess = () => {
        const { showNotification, updateCartData } = this.props;

        const quote_id = BrowserDatabase.getItem('guest_quote_id');

        return fetchQuery(CartQuery.getCartQuery(quote_id)).then(
            ({ cartData }) => {
                updateCartData(cartData);
                showNotification('success', __('All available products from your selection have been added to the cart!'))
                this.resetState();
            },
            this.handleError
        )
    }

    handleError = (error) => {
        const { showNotification } = this.props;

        showNotification('error', __('An error occurred. Try again.'))
        this.resetState();
    }

    resetState() {
        this.setState({
            isLoading: false,
            products: []
        });
    }

    render() {
        return (
            <BuyTogether
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyTogetherContainer);
